<div style="text-align:center" *ngIf="user == {}"><img src="/assets/img/red-loader.gif"/></div>
<div class="panel panel-default" *ngIf="user != {}">
  <div class="panel-heading">{{user?.DisplayName}} ({{user?.EmailAddress}})</div>
  <div class="panel-body">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <b>{{ 'common.roles' | translate }}</b>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-2"><span class="armx-icon armx-cashier"></span>{{ 'common.cashier' | translate }}</div>
        <div class="col-md-4 col-sm-4">
          <label class="switch">
            <input type="checkbox"
                   (change)="enableCashierSettings()"
                   [checked]="cashierEnable">

            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <user-settings-cashier-settings [Enabled]="cashierEnable"
                                      [type] ="type"
                                      (cashierSettings)="onSelectCashierSettings($event)"
                                      [defaultSettings]="user.Settings"
                                      (accounts)="onSelectAccounts($event)"
                                      [usersAccounts]="user.Accounts"></user-settings-cashier-settings>
      <div class="row">
        <div class="col-md-3 col-sm-2"><span class="armx-icon armx-operations"></span>{{ 'common.operations' | translate }}</div>
        <div class="col-md-4 col-sm-4">
          <label class="switch">
            <input type="checkbox"
                   (change)="enableOperations()"
                   [checked]="operationsEnable">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3 col-sm-2"><span class="armx-icon armx-out-mgr"></span>{{ 'common.outletManager' | translate }}</div>
        <div class="col-md-4 col-sm-4">
          <label class="switch">
            <input type="checkbox"
                   (change)="enableOutletMgr()"
                   [checked]="outletMgrEnable">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="row" *ngIf="type != 2">
        <div class="col-md-1 pull-right">
          <div class="form-group">
            <button class="btn btn-primary full-width" (click)="save()">{{ 'common.save' | translate }}</button>
          </div>
        </div>
        <div class="col-md-1 pull-right">
          <div class="form-group">
            <button class="btn btn-default full-width">{{ 'common.cancel' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


